import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyAttestatiService
 * Client API per attestati e scadenze del modulo "Gestione Adempimenti
 * Sicurezza".
 */
export default class SafetyAttestatiService {
    /** Elenco attestati/scadenze di un lavoratore (con stato calcolato). */
    static byLavoratore = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attestati/byLavoratore`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    /**
     * Sincronizza gli attestati LMS (corsi mappati 81) del lavoratore.
     * Ritorna { created, updated }.
     */
    static sync = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attestati/sync`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    /**
     * Crea un attestato MANUALE (corso esterno) con eventuale PDF.
     * @param {FormData} formData campi: id_lavoratore, data_rilascio, id_tipo,
     *        data_scadenza, titolo, numero_protocollo, ente_rilascio, ore, note, file
     */
    static createManuale = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/attestati/createManuale`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) un attestato. */
    static deleteAttestato = (id_safety_attestato) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attestati/delete`;
            ApiService.postRequest(resolve, reject, url, { id_safety_attestato });
        });
    };

    /** Scarica il PDF di un attestato MANUALE. */
    static downloadManuale = (id_safety_attestato, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/attestati/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_safety_attestato, filename });
        });
    };
}
